<template>
  <div>

    <section >
      <b-form @submit.prevent="onSubmit">
      <b-row>
         
         <b-col cols="8">
              <b-form-group
                id="form-group-for-list-name"
                label-for="list-name"
                :class="{ 'form-group--error': $v.listName.$error }"
              >
                <b-form-input id="list-name"   type="text" v-model.trim="$v.listName.$model" autocomplete="off" size="lg" placeholder="Create new list"></b-form-input>
                
              </b-form-group>
              <div class="error" v-if="!$v.listName.required">Field is required</div>
              <div class="error" v-if="!$v.listName.minLength">Name must have at least {{$v.listName.$params.minLength.min}} letters.</div>
         </b-col>
         <b-col cols="4">
            <b-button variant="primary" class="mb-2" size="lg" type="submit" :disabled="submitStatus === 'PENDING'">
               <b-icon icon="plus" aria-hidden="true" ></b-icon> ADD NEW
            </b-button>
         </b-col>
         <b-col cols="12">
          <p class="typo__p text-success" v-if="submitStatus === 'OK'">Order list created successfully</p>
          <p class="typo__p text-danger" v-if="submitStatus === 'ERROR'">Please fill the form correctly.</p>
          <p class="typo__p text-info" v-if="submitStatus === 'PENDING'">Sending request...</p>
         </b-col>
      </b-row>
      </b-form>
    </section>
  </div>
</template>

<script>
import { required, minLength } from 'vuelidate/lib/validators'
import Autocomplete from 'vuejs-auto-complete'
import OrdersListService from '../../../services/orders-list.service'
  export default {
    data(){
      return {
        listName: "",
        submitStatus: null
      }
    },
    validations: {
           listName: {
            required,
            minLength: minLength(4)
          },
        },
    methods: {
      async onSubmit(evt) {
        console.log('submit!')
          this.$v.$touch()
          if (this.$v.$invalid) {
            this.submitStatus = 'ERROR'
          } else {
            // do your submit logic here

            try{
              this.submitStatus = 'PENDING'
              const submitResult = await OrdersListService.addOrderList({name: this.listName});
              this.resetForm()
              this.submitStatus = 'OK'
            }
            catch(e){
              console.log(e);
              this.submitStatus = 'ERROR'

              this.$toasted.show(
                e.response.data.message,
                {
                  type: "error",
                  duration: 2000,
                  action: {
                    text: "Close",
                    class: "toastBtnTxt",
                    onClick: (e, toastObject) => {
                      toastObject.goAway(0);
                    },
                  },
                }
              );

            }
          }
      },
      resetForm() {
      this.listName = '';

      this.$nextTick(() => {
        this.$v.$reset();
      });
    },
    }
  }
</script>

<style lang="scss" scoped>
  .error{
    color: red;
    font-size: 12px;
    display: none;
    margin-top: -10px;
  }
  .form-group--error + .error{
     display: block;
  }
</style>